// src/redux/slices/activityLogSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getActivityLog } from "@/services/api/ActivityLog";

// Async thunk
export const getActivityLogThunk = createAsyncThunk(
  "activityLog/getActivityLog",
  async ({ search = "", pageNo = 1, perPage = 10 }: any = {}, { rejectWithValue }) => {
    try {
      const response = await getActivityLog(search, pageNo, perPage);
      // Handle both results (tags-style) and content (page-style)
      // Check res.data.data.results, res.data.data.content, etc.
      const data = response?.data?.results || response?.data?.content || response?.data || [];
      return {
        results: Array.isArray(data) ? data : [],
        totalRecord: response?.data?.totalRecord || 0,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Error fetching activity log");
    }
  }
);

const activityLogSlice = createSlice({
  name: "activityLog",
  initialState: {
    activityLog: [],
    totalRecords: 0,
    loading: false,
    error: null as string | null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getActivityLogThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActivityLogThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.activityLog = action.payload.results as any;
        state.totalRecords = action.payload.totalRecord;
        console.log(action.payload);

      })
      .addCase(getActivityLogThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default activityLogSlice.reducer;